export const NAV = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/custom-orders", label: "Custom Orders" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const INSTAGRAM = "https://www.instagram.com/lises.sugar.studio/";
export const HANDLE = "@Lises.Sugar.Studio";
export const EMAIL = "LisesSugarStudio@proton.me";

export const THANKSGIVING_PICKUP = { iso: "2026-11-24", label: "Tuesday, November 24", orderBy: "2026-11-18", orderByLabel: "Wednesday, November 18" };

export const thanksgivingOpen = () => new Date() < new Date(`${THANKSGIVING_PICKUP.orderBy}T23:59:59-05:00`);

export const COLLECTION = [
  { slug: "cupcakes", name: "Cupcakes", note: "Mix & match your box", price: "From $5", img: "/img/cupcakes-banana-biscoff-group.jpg", area: "md:col-span-2 lg:col-span-2 lg:row-span-2" },
  { slug: "signature-cookies", name: "Cookies", note: "Mix & match your box", price: "From $5", img: "/img/flavor-biscoff-crunch.jpg", area: "lg:col-span-2" },
  { slug: "cheesecake-slices", name: "Cheesecake Slices", note: "Peach Cobbler · Biscoff Apple Pie", price: "From $6", img: "/img/cheesecake-peach-cobbler.jpg", area: "lg:col-span-2" },
];

export const CHEESECAKES = [
  { name: "Peach Cobbler", img: "/img/cheesecake-peach-cobbler.jpg", desc: "Creamy cheesecake with spiced peaches and a buttery cobbler crumble, finished with caramel and whipped cream." },
  { name: "Biscoff Apple Pie", img: "/img/cheesecake-biscoff-apple-pie.jpg", desc: "Creamy cheesecake swirled with Biscoff and topped with caramel apple pie filling, buttery crumble and whipped cream." },
];

export const OCCASIONS = ["Birthdays", "Celebrations", "Showers", "Corporate Events", "Special Occasions"];

export const STEPS = [
  { n: "01", t: "Inquire", d: "Share your date, guest count and the desserts you have in mind." },
  { n: "02", t: "Design", d: "We refine flavours, quantities and finishing details together." },
  { n: "03", t: "Pick up", d: "Your order is baked fresh. Pickup details arrive once payment is received." },
];

export const TESTIMONIALS = [
  { q: "I tried the cookies and they are really good. My daughter also said they were really good so I will def be back. I also sent your page to my old college teammate as well. Thank you again.", who: "Shy T.", occasion: "Cookies" },
  { q: "I almost ate the whole chocolate chunk cookie, but I stopped so my husband could taste as well. So fresh, delicious, moist.", who: "Emery", occasion: "Chocolate chunk cookie" },
  { q: "Thanks again for my cookies! They were so good. But that chocolate chip cookie & sugar cookie… Girl! They didn’t even make it home!", who: "Taneesha", occasion: "Cookies" },
  { q: "My wife ordered some of your cookies to surprise me on Sunday… they are SO GOOD.", who: "JosG", occasion: "Surprise gift" },
  { q: "Omgoodness those sugar cookies were delicious and was that your brown butter chocolate chip please they were good too. The chips were big. How do you do that?", who: "Lynn M.", occasion: "Sugar & brown butter cookies" },
];

export const GALLERY = [
  { src: "/img/flavor-biscoff-crunch.jpg", alt: "Biscoff Crunch cookie" },
  { src: "/img/cupcakes-banana-biscoff-group.jpg", alt: "Banana Biscoff cupcakes" },
  { src: "/img/flavor-red-brookie.jpg", alt: "Red Brookie cookie" },
  { src: "/img/flavor-brown-butter-chocolate-chip.jpg", alt: "Brown Butter Chocolate Chip cookie" },
  { src: "/img/cupcake-banana-biscoff.jpg", alt: "Banana Biscoff cupcake" },
  { src: "/img/flavor-salted-caramel-pretzel.jpg", alt: "Salted Caramel Pretzel cookie" },
  { src: "/img/flavor-snickerdoodle-cheesecake.jpg", alt: "Snickerdoodle Cheesecake cookie" },
  { src: "/img/flavor-caramel-apple-pie.jpg", alt: "Caramel Apple Pie cookie" },
  { src: "/img/flavor-hot-chocolate.jpg", alt: "Hot Chocolate cookie" },
  { src: "/img/flavor-stroopwafel-choco-chip.jpg", alt: "Stroopwafel & Choco Chip cookie" },
  { src: "/img/flavor-oatmeal-cream-pie.jpg", alt: "Oatmeal Cream Pie cookie" },
  { src: "/img/flavor-white-chocolate-pumpkin.jpg", alt: "White Chocolate Pumpkin cookie" },
  { src: "/img/flavor-banana-pudding.jpg", alt: "Banana Pudding cookie" },
  { src: "/img/cheesecake-peach-cobbler.jpg", alt: "Peach Cobbler cheesecake slice" },
  { src: "/img/cheesecake-biscoff-apple-pie.jpg", alt: "Biscoff Apple Pie cheesecake slice" },
];
